import { Instance } from 'mobx-state-tree'
import { WebQuestionAnswersTypeModelBase } from './WebQuestionAnswersTypeModel.base'

/* The TypeScript type of an instance of WebQuestionAnswersTypeModel */
export interface WebQuestionAnswersTypeModelType extends Instance<typeof WebQuestionAnswersTypeModel.Type> {}

/* A graphql query fragment builders for WebQuestionAnswersTypeModel */
export {
  selectFromWebQuestionAnswersType,
  webQuestionAnswersTypeModelPrimitives,
  WebQuestionAnswersTypeModelSelector
} from './WebQuestionAnswersTypeModel.base'

/**
 * WebQuestionAnswersTypeModel
 */
export const WebQuestionAnswersTypeModel = WebQuestionAnswersTypeModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
